exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".main___1NkDC {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: center;\n        justify-content: center;\n    -ms-flex-align: center;\n        align-items: center;\n    -ms-flex-direction: column;\n        flex-direction: column;\n    padding: 18px;\n  }\n\n.p___3SdHU{\n    font-size: 15px;\n    text-indent: 2em;\n    margin-bottom: 1rem;\n    line-height: 27px;\n    text-align: unset;\n    color: #222222;\n    letter-spacing: 2px;\n}", ""]);

// exports
exports.locals = {
	"main": "main___1NkDC",
	"p": "p___3SdHU"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/css/IntroduceDetail.css
// module id = 787
// module chunks = 2